import TruemedWidget from './TruemedWidget';

export default TruemedWidget;
